/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { WindowSize } from '../WindowSize.js';
import { useNavigate } from 'react-router-dom';
import { GetUrl, CTicksToDateString, formatNumber } from '../Utility.js';

import Title from './Title.js';

function PointRechargeApply() {

  const state=useSelector((state)=>state);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [SearchString, setSearchString] = useState('');
  const [contentView, setContentView] = useState(0); // 드롭다운 보임/숨김 상태
  const [searchItem, setSearchItem] = useState("아이디"); // 선택된 드롭다운 항목
  const [pageIndex, setpageIndex] = useState(0); // 선택된 드롭다운 항목
  const [totalCount, setTotalCount] = useState(0); // 선택된 드롭다운 항목
  const [viewIndex, setviewIndex] = useState(0); // 선택된 드롭다운 항목
  
  const dropdown = () => {
    setContentView((prev) => (prev === 0 ? 1 : 0)); // 열기/닫기 토글
  };

  const getSearchItem = () => searchItem;

  const setSerarchItem = (item) => {
    const items = ["아이디", "닉네임", "이름"];
    setSearchItem(items[item]);
    setContentView(0); // 항목 선택 시 드롭다운 닫기
  };

  function Search()
  {
    if(SearchString === '')
    {
        return;
    }
  }

  function Refresh()
  {
    if(state.Request === 1)
    {
        return;
    }

    setTotalCount(0);
    setpageIndex(0);
    setviewIndex(1);
    RequestRechargeApplySearch(1);
  }

  function GetPageNumber(number)
  {
    return (pageIndex * 10) + number;
  }

  function NextPage()
  {
    if(totalCount === 0)
    {
        return;
    }

    var maxIndex = Math.ceil(totalCount / 15);
    if(viewIndex === maxIndex)
    {
        return;
    }

    var newViewIndex = viewIndex + 1;
    ClickViewIndex(newViewIndex);  
    setpageIndex(Math.floor((newViewIndex - 1) / 15));
  }

  function PrevPage()
  {
    if(totalCount === 0 ||
        viewIndex === 1)
    {
        return;
    }

    var newViewIndex = viewIndex - 1;
    ClickViewIndex(newViewIndex);
    setpageIndex(Math.floor((newViewIndex - 1) / 15));
  }

  function ClickViewIndex(index)
  {
    if(totalCount === 0)
    {
        return;
    }
    
    if(state.Request === 1)
    {
        return;
    }
    
    if(viewIndex === index)
    {
        return;
    }

    var maxIndex = Math.ceil(totalCount / 15);
    if(maxIndex < index)
    {
        return;
    }

    setviewIndex(index);
    RequestRechargeApplySearch(index);
  }

  const RequestRechargeApplySearch = async (index) => 
    {
        try
        {
            if(state.Request === 1)
            {
                return;
            }

            var secretkey = sessionStorage.getItem("secret_key");
            if(secretkey === null)
            {
              alert('유저 정보 만료(다시 로그인 해주세요)');  
              navigate('/login'); // 로그인 성공 시 메인 페이지로 이동  
              return;    
            }
            
            dispatch({type:'Request'});
            const response = await fetch(GetUrl() + 'Admin/RechargePointApplyLog', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ secret_key : secretkey, start_index : index - 1, content_count : 15}),
            });

            if (response.ok) {
                const data = await response.json();
                if(data.result === 0)
                {
                    dispatch({type:'UpdatePointRechargeApplyArray', Log:data.recharge_point_datas});  
                    setTotalCount(data.total_count);
                }
                else if(data.result === 14 ||
                        data.result === 16)
                {
                    alert('존재 하지 않는 티켓 입니다');  
                }
                else if(data.result === 15)
                {
                    alert('이미 사용한 티켓 입니다');  
                }
                else if(data.result === 3 ||
                        data.result === 1)
                {
                    alert('유저 정보 만료(다시 로그인 해주세요)');  
                    navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                }
                else if(data.result === 21) // 점검 중
                {
                  var startTime = CTicksToDateString(data.start_time);
                  var endTime = CTicksToDateString(data.end_time);
    
                  var message = `${startTime} ~ ${endTime} 점검 중 입니다. 잠시후에 이용해 주세요`;
                  alert(message);  
                  navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                }
            } 
            else
            {
                alert('Network Fail');
            }

            dispatch({type:'Response'});
        }
        catch(error)
        {
            alert('Network Fail');
            dispatch({type:'Response'});
            console.error(error);
        }
    };

    if(state.RechargeApplyFirstRender === false)
    {
        dispatch({type:'RechargeApplyFirstRender'});
        setTotalCount(0);
        setpageIndex(0);
        setviewIndex(1);
        RequestRechargeApplySearch(1);
    }

    function GetNumber(index)
    {
        if(state.PointRechargeApplyArray === undefined || state.PointRechargeApplyArray.length <= index)
        {
            return'';
        }

        return state.PointRechargeApplyArray[index].sn;
    }

    function GetID(index)
    {
        if(state.PointRechargeApplyArray === undefined || state.PointRechargeApplyArray.length <= index)
        {
            return'';
        }

        return state.PointRechargeApplyArray[index].email;
    }

    function GetNickName(index)
    {
        if(state.PointRechargeApplyArray === undefined || state.PointRechargeApplyArray.length <= index)
        {
            return'';
        }

        return state.PointRechargeApplyArray[index].nickname;
    }

    function GetName(index)
    {
        if(state.PointRechargeApplyArray === undefined || state.PointRechargeApplyArray.length <= index)
        {
            return'';
        }

        return state.PointRechargeApplyArray[index].username;
    }

    function GetRechargePoint(index)
    {
        if(state.PointRechargeApplyArray === undefined || state.PointRechargeApplyArray.length <= index)
        {
            return'';
        }

        return formatNumber(state.PointRechargeApplyArray[index].money) + 'P';
    }


    function GetRegisterTime(index)
    {
        if(state.PointRechargeApplyArray === undefined || state.PointRechargeApplyArray.length <= index)
        {
            return'';
        }

        return CTicksToDateString(state.PointRechargeApplyArray[index].createattime_ticks);
    }

    function GetState(index)
    {
      if(state.PointRechargeApplyArray === undefined || state.PointRechargeApplyArray.length <= index)
        {
            return'';
        }

        if(state.PointRechargeApplyArray[index].state === 1)
        {
          return "승인";
        }
        else
        {
          return "거절";
        }
    }

    function GetApplyTime(index)
    {
      if(state.PointRechargeApplyArray === undefined || state.PointRechargeApplyArray.length <= index)
        {
            return'';
        }

        return CTicksToDateString(state.PointRechargeApplyArray[index].apply_time_ticks);
    }

    function GetApplyID(index)
    {
      if(state.PointRechargeApplyArray === undefined || state.PointRechargeApplyArray.length <= index)
        {
            return'';
        }

        return state.PointRechargeApplyArray[index].apply_id;
    }
 

  return (
    <div id='Player_Range'>
        <Title DisplayType="2"></Title>
        <div className='search-box'>
            <div className='dropdown_parent'>
                <div className="dropdown-label">검색 조건</div>
                <div className="dropdown">
                    <button className="dropbtn">
                    <span className="dropbtn_icon">more_horiz</span>
                    <span className="dropbtn_content">{getSearchItem()}</span>
                    <span
                        className="dropbtn_click"
                        style={{
                        fontFamily: "Material Icons",
                        fontSize: "16px",
                        color: "#3b3b3b",
                        float: "right",
                        }}
                        onClick={dropdown}
                    >
                        arrow_drop_down
                    </span>
                    </button>
                    <div
                    className="dropdown-content"
                    style={{ display: contentView === 0 ? "none" : "block" }}
                    >
                    <div className="fastfood" onClick={() => setSerarchItem(0)}>
                        아이디
                    </div>
                    <div className="fastfood" onClick={() => setSerarchItem(1)}>
                        닉네임
                    </div>
                    <div className="fastfood" onClick={() => setSerarchItem(2)}>
                        이름
                    </div>
                    </div>
                </div>
            </div>
            <input
                type="search"
                placeholder="검색 입력"
                value={SearchString}
                onChange={(e) => setSearchString(e.target.value)}
            />
            <div className='search_button' onClick={() => Search()}>검색</div>
            <div className='search_button' onClick={() => Refresh()}>최신목록</div>
            <div className='total_count'><h2>승인 : {formatNumber(totalCount)}</h2></div>
        </div>
        <div className='point-recharge-apply-box'>
            <div className='point-recharge-apply-box-table'>
                <tr>
                    <th style={{width:"5%"}}>넘버</th>
                    <th style={{width:"10%"}}>아이디</th>
                    <th style={{width:"10%"}}>닉네임</th>
                    <th style={{width:"10%"}}>이름</th>
                    <th style={{width:"10%"}}>충전 포인트</th>
                    <th style={{width:"15%"}}>등록 일시</th>
                    <th style={{width:"10%"}}>상태</th>
                    <th style={{width:"15%"}}>승인 일시</th>
                    <th style={{width:"10%"}}>승인 아이디</th>
                </tr>
                {Array.from({length:15}).map((_, index)=>(
                    <tr>
                        <td style={{textAlign:"center"}}>{GetNumber(index)}</td>
                        <td style={{textAlign:"center"}}>{GetID(index)}</td>
                        <td style={{textAlign:"center"}}>{GetNickName(index)}</td>
                        <td style={{textAlign:"center"}}>{GetName(index)}</td>
                        <td style={{textAlign:"center"}}>{GetRechargePoint(index)}</td>
                        <td style={{textAlign:"center"}}>{GetRegisterTime(index)}</td>
                        <td style={{textAlign:"center"}}>{GetState(index)}</td>
                        <td style={{textAlign:"center"}}>{GetApplyTime(index)}</td>
                        <td style={{textAlign:"center"}}>{GetApplyID(index)}</td>
                    </tr>
                ))}
            </div>
            <div className='point-recharge-apply-box-count-box'>
                <div className='point-recharge-apply-box-count' onClick={() => PrevPage()}><h2>{"<"}이전</h2></div>
                <div className='point-recharge-apply-box-count' onClick={() => ClickViewIndex(GetPageNumber(1))}><h2>{GetPageNumber(1)}</h2></div>
                <div className='point-recharge-apply-box-count' onClick={() => ClickViewIndex(GetPageNumber(2))}><h2>{GetPageNumber(2)}</h2></div>
                <div className='point-recharge-apply-box-count' onClick={() => ClickViewIndex(GetPageNumber(3))}><h2>{GetPageNumber(3)}</h2></div>
                <div className='point-recharge-apply-box-count' onClick={() => ClickViewIndex(GetPageNumber(4))}><h2>{GetPageNumber(4)}</h2></div>
                <div className='point-recharge-apply-box-count' onClick={() => ClickViewIndex(GetPageNumber(5))}><h2>{GetPageNumber(5)}</h2></div>
                <div className='point-recharge-apply-box-count' onClick={() => ClickViewIndex(GetPageNumber(6))}><h2>{GetPageNumber(6)}</h2></div>
                <div className='point-recharge-apply-box-count' onClick={() => ClickViewIndex(GetPageNumber(7))}><h2>{GetPageNumber(7)}</h2></div>
                <div className='point-recharge-apply-box-count' onClick={() => ClickViewIndex(GetPageNumber(8))}><h2>{GetPageNumber(8)}</h2></div>
                <div className='point-recharge-apply-box-count' onClick={() => ClickViewIndex(GetPageNumber(9))}><h2>{GetPageNumber(9)}</h2></div>
                <div className='point-recharge-apply-box-count' onClick={() => ClickViewIndex(GetPageNumber(10))}><h2>{GetPageNumber(10)}</h2></div>
                <div className='point-recharge-apply-box-count' onClick={() => NextPage()}><h2>다음{">"}</h2></div>
            </div>
        </div>
    </div>
  );
}

export default PointRechargeApply;